import React, { useState, useContext, useEffect, memo } from "react";
import { Popup } from "react-map-gl";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import Context from "../../context";
import API from "../../API";

import SurfReportForm from "./SurfReportForm";

const SurfSpotInfoPopup = memo(function SurfSpotInfoPopup(props) {
    const { setSurfSpots } = useContext(Context);
    // const { setAddSurfSpot, surfSpots, setSurfSpots } = useContext(Context);
    const { coords, address, description, name, _id } = props.info;
    console.log(props);

    const [longitude, latitude] = coords.coordinates;

    const [edit, setEdit] = useState(false);

    const [newName, setNewName] = useState(name);
    const [newDescription, setNewDescription] = useState(description);
    const [nameError, setNameError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [addSurfReport, setAddSurfReport] = useState(false);

    async function handleDelete() {
        const confirmDelete = confirm("Delete?");
        if (confirmDelete) {
            const deleted = await API.deleteSurfSpot(_id);
            setSurfSpots((surfSpots) => {
                const newSurfSpots = surfSpots.filter((spot) => spot._id !== _id);
                props.setInfo(false);
                return newSurfSpots;
            });
        }
    }

    async function handleEdit() {
        const updatedSurfSpot = await API.editSurfSpot({
            id: _id,
            name: newName,
            description: newDescription,
        });

        setSurfSpots((surfSpots) => {
            const newSurfSpots = surfSpots.filter((spot) => spot._id !== _id);
            newSurfSpots.push(updatedSurfSpot);

            return newSurfSpots;
        });
        props.setInfo(updatedSurfSpot);
        setEdit(false);
    }

    console.log(address);

    return (
        <Popup
            // offsetTop={20}
            // tipSize={5}
            anchor="top"
            longitude={longitude}
            latitude={latitude}
            closeOnClick={false}
            onClose={() => props.setInfo(false)}
            style={{
                width: "400px",
                minWidth: addSurfReport ? "400px" : "300px",
                border: "1px solid white",
                zIndex: 10000,
            }}
        >
            {submitting && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: "0px",
                        top: "0px",
                        left: "0px",
                        right: "0px",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress size={150} />
                </Box>
            )}

            <Grid container sx={{ position: "relative" }}>
                <Grid item container xs={6}>
                    <Grid item sx={{ fontSize: 10 }} xs={12}>
                        <div>{`LAT: ${latitude.toFixed(5)}`} </div>
                    </Grid>

                    <Grid item sx={{ fontSize: 10 }} xs={12}>
                        <div>{`LON: ${longitude.toFixed(5)}`} </div>
                    </Grid>
                </Grid>
                <Grid
                    item
                    container
                    xs={6}
                    sx={{
                        textAlign: "center",
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    {/* //google places api put on hold */}
                    {address != "false" && (
                        <Grid item xs={12}>
                            <Grid
                                item
                                sx={{
                                    fontSize: 12,
                                    fontWeight: "bold",
                                    // textAlign: "center",
                                }}
                            >
                                {address}
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>

            <Grid item container xs={12}>
                <Grid item sx={{ fontWeight: "bold" }}>
                    <span>NAME:</span>
                </Grid>

                {!edit && (
                    <Grid style={{ paddingLeft: 10, fontWeight: "bold" }} item xs={8}>
                        {name}
                    </Grid>
                )}
                {edit && (
                    <Grid item xs={12}>
                        <TextField
                            inputProps={{
                                autoComplete: "off",
                            }}
                            fullWidth
                            error={nameError}
                            required
                            id="standard-basic"
                            label="Surf Sport Name"
                            variant="standard"
                            value={newName}
                            type="text"
                            onChange={(e) => {
                                if (nameError) {
                                    setNameError(false);
                                }
                                setNewName(e.target.value);
                            }}
                            sx={{
                                "& .MuiInputBase-input": { color: "white" },
                                "& .MuiInputLabel-root": { color: "white" },
                                "& .MuiInput-underline:before": { borderBottomColor: "white" },
                                "& .MuiInput-underline:hover:before": { borderBottomColor: "white" },
                                "& .MuiInput-underline:after": { borderBottomColor: "white" },
                            }}
                        />
                    </Grid>
                )}
            </Grid>
            {addSurfReport && (
                <Grid item container sx={{ maxWidth: 400 }} xs={12}>
                    <SurfReportForm info={props.info} setAddSurfReport={setAddSurfReport} />
                </Grid>
            )}

            {!addSurfReport && (
                <>
                    <Grid item container xs={12}>
                        <Grid item xs={4} sx={{ fontWeight: "bold" }}>
                            <span>DESC:</span>
                        </Grid>

                        {!edit && (
                            <Grid item xs={8}>
                                {description}
                            </Grid>
                        )}

                        {edit && (
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    error={descriptionError}
                                    aria-label="empty textarea"
                                    placeholder="Description"
                                    required
                                    minRows={3}
                                    maxRows={6}
                                    multiline
                                    style={{ width: 200 }}
                                    type="text"
                                    value={newDescription}
                                    onChange={(e) => {
                                        if (descriptionError) {
                                            setDescriptionError(false);
                                        }
                                        setNewDescription(e.target.value);
                                    }}
                                    sx={{
                                        "& .MuiInputBase-input": { color: "white" },
                                        "& .MuiInputBase-input::placeholder": { color: "rgba(255, 255, 255, 0.7)" },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": { borderColor: "white" },
                                            "&:hover fieldset": { borderColor: "white" },
                                        },
                                    }}
                                />
                            </Grid>
                        )}
                    </Grid>
                    <Grid item container xs={12}>
                        {/* <ButtonGroup size="small" variant="contained"> */}
                        {edit && (
                            <Grid item xs={3}>
                                <Button
                                    onClick={() => handleEdit()}
                                    variant="contained"
                                    color={"success"}
                                    // endIcon={<CheckIcon />}
                                >
                                    OK
                                </Button>
                            </Grid>
                        )}

                        <Grid item xs={4}>
                            {!edit && (
                                <Button onClick={() => setEdit(true)} variant="contained" color={"secondary"}>
                                    EDIT
                                </Button>
                            )}
                            {edit && (
                                <Button
                                    onClick={() => {
                                        setEdit(false);
                                        setNewName(name);
                                        setNewDescription(description);
                                    }}
                                    variant="contained"
                                    color={"secondary"}
                                    // endIcon={<CancelIcon />}
                                >
                                    CANCEL
                                </Button>
                            )}
                        </Grid>
                        {!edit && (
                            <Grid item xs={8}>
                                <Button
                                    onClick={() => setAddSurfReport(true)}
                                    variant="outlined"
                                    color={"primary"}
                                    // endIcon={<SummarizeIcon />}
                                >
                                    ADD REPORT
                                </Button>
                            </Grid>
                        )}

                        {edit && (
                            <Grid item xs={5}>
                                <Button
                                    onClick={() => handleDelete()}
                                    variant="outlined"
                                    color={"error"}
                                    // endIcon={<DeleteIcon />}
                                >
                                    DELETE
                                </Button>
                            </Grid>
                        )}
                        {/* </ButtonGroup> */}
                    </Grid>
                </>
            )}
        </Popup>
    );
});

export default SurfSpotInfoPopup;
